import React from 'react'
import Text from '../Text'
import styles from './styles.module.css'

function CategoryTitle({ children, color }) {
  return (
    <div className={styles.wrapper} style={{ color }}>
      <Text type="h4">{children}</Text>
    </div>
  )
}

export default CategoryTitle
